import { render, staticRenderFns } from "./PatientRequests.vue?vue&type=template&id=66321f69&scoped=true"
import script from "./PatientRequests.vue?vue&type=script&lang=js"
export * from "./PatientRequests.vue?vue&type=script&lang=js"
import style0 from "./PatientRequests.vue?vue&type=style&index=0&id=66321f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66321f69",
  null
  
)

export default component.exports